import ApiClient from '../ApiClient';
import { API_CONFIG } from '../config';

const mainApiClient = new ApiClient({
  baseUrl: API_CONFIG.baseUrl,
  refreshPath: API_CONFIG.refreshPath,
});

export default mainApiClient;
